import React from "react";
import { Sparkles, MapPin, Star } from "lucide-react";

// A clearly-labelled EXAMPLE request shown on the driver dashboard while online
// and idle, so the empty state feels alive and new drivers know what to expect.
export default function SampleRequestCard({ mode = "rides" }) {
  const isFood = mode === "food";
  return (
    <div className="mt-5 rounded-2xl border border-dashed border-brand-200 bg-brand-50/40 p-4" data-testid="sample-request-card">
      <div className="mb-3 flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-brand" />
        <span className="text-xs font-semibold uppercase tracking-wide text-brand">Example {isFood ? "delivery" : "ride"} request</span>
      </div>
      <div className="rounded-xl border border-surface-200 bg-white p-4 opacity-90">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-semibold text-ink">{isFood ? "Hilltop Kitchen" : "Akum M."}</p>
            <p className="inline-flex items-center gap-1 text-xs text-ink-soft"><Star className="h-3 w-3 fill-brand text-brand" /> {isFood ? "2 items · Prepaid" : "4.9"}</p>
          </div>
          <p className="text-xl font-bold text-ink">{isFood ? "₹60" : "₹182"}</p>
        </div>
        <div className="mt-3 space-y-1.5 text-xs">
          <p className="flex items-center gap-2 text-ink"><span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-50"><MapPin className="h-3 w-3 text-brand" /></span>{isFood ? "Pick up · Hilltop Kitchen, Razhü Point" : "Pickup · Razhü Point, Kohima"}</p>
          <p className="flex items-center gap-2 text-ink"><span className="flex h-5 w-5 items-center justify-center rounded-full bg-graphite-50"><MapPin className="h-3 w-3 text-graphite" /></span>{isFood ? "Deliver · High School Junction" : "Drop · BOC, Kohima · 5.2 km"}</p>
        </div>
      </div>
      <p className="mt-3 text-xs text-ink-muted">This is a preview. Real requests ring loudly and show <span className="font-semibold text-ink">Accept</span> and <span className="font-semibold text-ink">Skip</span> buttons here.</p>
    </div>
  );
}
